import { Stack } from "@mui/material";
import SearchFilterChip from "./SearchFilterChip";
import TimeRangeFilterChip from "./TimeRangeFilterChip";
import BrandFilterChip from "./BrandFilterChip";
import CategoryPathFilterChip from "./CategoryPathFilterChip";
import AdStateFilterChip from "./AdStateFilterChip";

export default function FilterChipStack() {
  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      <SearchFilterChip />
      <TimeRangeFilterChip />
      <BrandFilterChip />
      <CategoryPathFilterChip />
      <AdStateFilterChip />
    </Stack>
  );
}
